import { cn } from "@/lib/utils";

// Import all maozinha SVGs
import apontandoSvg from "@/assets/brand/maozinhas/apontando.svg";
import joiaSvg from "@/assets/brand/maozinhas/joia.svg";
import okSvg from "@/assets/brand/maozinhas/ok.svg";
import pazSvg from "@/assets/brand/maozinhas/paz.svg";

export type MaozinhaVariant = "apontando" | "joia" | "ok" | "paz";

const maozinhaMap: Record<MaozinhaVariant, string> = {
  apontando: apontandoSvg,
  joia: joiaSvg,
  ok: okSvg,
  paz: pazSvg,
};

const sizeMap = {
  sm: "w-8 h-8",
  md: "w-12 h-12",
  lg: "w-16 h-16",
  xl: "w-24 h-24",
};

interface AuliMaozinhaProps {
  variant: MaozinhaVariant;
  size?: keyof typeof sizeMap;
  className?: string;
  alt?: string;
}

/**
 * Componente wrapper para as Mãozinhas da marca Auli
 * Uso: <AuliMaozinha variant="apontando" size="lg" />
 * 
 * Contextos recomendados:
 * - apontando: Próximo a CTAs principais para direcionar atenção
 * - joia/ok: Feedback positivo após ações bem-sucedidas
 * - paz: Boas-vindas e onboarding
 */
export const AuliMaozinha = ({
  variant,
  size = "md",
  className,
  alt,
}: AuliMaozinhaProps) => {
  const defaultAlt = {
    apontando: "Mãozinha apontando",
    joia: "Mãozinha jóia",
    ok: "Mãozinha OK",
    paz: "Mãozinha paz",
  };

  return (
    <img
      src={maozinhaMap[variant]}
      alt={alt || defaultAlt[variant]}
      className={cn(sizeMap[size], "select-none", className)}
      draggable={false}
    />
  );
};
